import styled from 'styled-components';
import { PRIMARY, VIOLET_600 } from '@styles/colors';
import { GIVONIC, INTER } from '@styles/fonts';

// Import background images
import CompletedProcessBG from '@assets/images/CompletedProcessBackground.png';
import CompletedProcessIconBG from '@assets/images/LightGradientBackground.png';
import { safeAreaInset } from '@lib/telegram';

// Export types for TypeScript
export interface CompletedProcessStylesProps {}

export const Container = styled.div<CompletedProcessStylesProps>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-image: url(${CompletedProcessBG});
  background-size: cover;
  background-position: center;
  padding: 0 12px;
  justify-content: space-between;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 0px;
  margin: 0px 0px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${CompletedProcessIconBG});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  justify-content: center;
  margin-top: 10vh;
  border-radius: 16px;
  padding: 5vh 3vw 10vh 3vw;
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${CompletedProcessIconBG});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 24px;
    z-index: -1;
  }
`;

export const Icon = styled.img`
  width: 50vw;
  height: 50vw;
  object-fit: contain;
  margin: 0 0 -5vh 0;
`;

export const Title = styled.h1`
  font-family: ${GIVONIC.black};
  font-size: 16px;
  color: ${VIOLET_600};
  margin: 1vh 0;
  text-align: center;
`;

export const Description = styled.p`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: #333;
  text-align: center;
  max-width: 80%;
  margin: 0 0;
`;

export const ButtonContainer = styled.div`
  margin-bottom: ${safeAreaInset().bottom || 24}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2vh;
`;

export const LinkText = styled.a`
  font-family: ${INTER.medium};
  font-size: 13px;
  color: ${PRIMARY};
  text-decoration: underline;
  cursor: pointer;
  margin-top: 16px;
`;

export const CenteredContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
`;
